export default "__VITE_ASSET__DdjR3RAU__"